/* eslint-disable react/prop-types */ // TODO: add props
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Button, ModalCloseCrossIcon } from 'edrolo-style-guide';
import { EXAM_ANALYTICS_CONSTANTS } from '../../constants';
import TeacherQuestionView from '../TeacherQuestionView';
import style from './QuestionInstructionsModal.scss';

const QuestionInstructionsModal = ({
  examId,
  question,
  show,
  onCancel,
  questionReviewUrl,
  analyticsPayload,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        onCancel();

        global.analytics.track(
          EXAM_ANALYTICS_CONSTANTS.EVENTS.CLOSED_QUESTION_INFORMATION_MODAL,
          {
            origin: analyticsPayload.origin,
            page: analyticsPayload.page,
            class_id: analyticsPayload.classId,
            lesson_id: analyticsPayload.lessonId,
            exam_id: analyticsPayload.examId,
            question_id: question.get('id'),
            method: 'clicked outside modal',
          }
        );
      }}
      animation={false}
    >
      <Modal.Header className={style.header}>
        <span
          className={style.crossIcon}
          onClick={() => {
            onCancel();

            global.analytics.track(
              EXAM_ANALYTICS_CONSTANTS.EVENTS.CLOSED_QUESTION_INFORMATION_MODAL,
              {
                origin: analyticsPayload.origin,
                page: analyticsPayload.page,
                class_id: analyticsPayload.classId,
                lesson_id: analyticsPayload.lessonId,
                exam_id: analyticsPayload.examId,
                question_id: question.get('id'),
                method: 'clicked cross icon',
              }
            );
          }}
        >
          <ModalCloseCrossIcon />
        </span>
      </Modal.Header>
      <Modal.Body>
        {show && (
          <>
            <p className={style.heading}>Q{question.get('full_serial')}</p>
            <div className={style.message}>
              <TeacherQuestionView
                questionId={question.get('id')}
                examId={examId}
              />
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          outline
          onClick={() => {
            onCancel();

            global.analytics.track(
              EXAM_ANALYTICS_CONSTANTS.EVENTS.CLOSED_QUESTION_INFORMATION_MODAL,
              {
                origin: analyticsPayload.origin,
                page: analyticsPayload.page,
                class_id: analyticsPayload.classId,
                lesson_id: analyticsPayload.lessonId,
                exam_id: analyticsPayload.examId,
                question_id: question.get('id'),
                method: 'clicked close button',
              }
            );
          }}
          className={style.cancelButton}
        >
          Close
        </Button>
        <Link to={questionReviewUrl}>
          <Button
            onClick={() =>
              global.analytics.track(
                EXAM_ANALYTICS_CONSTANTS.EVENTS
                  .CLICKED_QUESTION_INFORMATION_MODAL_VIEW_STUDENT_RESPONSES_BUTTON,
                {
                  origin: analyticsPayload.origin,
                  page: analyticsPayload.page,
                  class_id: analyticsPayload.classId,
                  lesson_id: analyticsPayload.lessonId,
                  exam_id: analyticsPayload.examId,
                  question_id: question.get('id'),
                }
              )
            }
          >
            View student responses
          </Button>
        </Link>
      </Modal.Footer>
    </Modal>
  );
};

export default QuestionInstructionsModal;
